if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      variantMap = [];
      productUrl = '';
      _flavorChangeHandler = null;
      // MNR-777: von assets/sales-agent-events.js gesetzt, hier zurückgesetzt.
      _addSucceeded = false;
      _closing = false;
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        // MNR-777: Ein nie geöffnetes Modal hat nichts zu schließen. QuickAdd-external
        // steht auf jeder Seite im DOM und ist nur opacity-0/z-[-1] — die
        // visibility:hidden-Regel in quick-add.css greift nur auf die Klasse
        // .quick-add-modal, die dieses Element nicht trägt. Sein Close-Button ist
        // dadurch tabbar, und ModalDialog bindet ihn ohne open-Guard.
        if (!this.hasAttribute('open')) return;

        // ModalDialog bindet X, Escape und Backdrop ohne open-Guard auf hide(),
        // und super.hide() entfernt `open` erst nach 300ms — ohne diesen Guard
        // senden zwei Klicks in dem Fenster zwei Abandonment-Events.
        if (this._closing) {
          // preventFocus trotzdem respektieren: schließt der Kunde von Hand,
          // bevor atcAnimationComplete das hide(true) aus product-form.js
          // auslöst, würde der Fokus sonst auf den Opener zurückspringen — beim
          // externen Chatbot-Modal ein bereits entfernter Fake-Button.
          if (preventFocus) this.openedBy = null;
          return;
        }
        this._closing = true;

        super.hide();
        this.removeFlavorChangeListener();
        // Add tracking event
        publish(PUB_SUB_EVENTS.closeQuickAdd, {
          source: 'quick-add',
          modalContent: this.modalContent,
          modalId: this.id,
          // true = in dieser Session wurde gekauft, das Schließen ist also kein
          // Abandonment (egal ob das Modal sich selbst schließt oder der Kunde).
          addSucceeded: this._addSucceeded === true,
        })
        // End tracking

        setTimeout(() => {
          const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (cartNotification) cartNotification.setActiveElement(this.openedBy);
          this.modalContent.innerHTML = '';

          if (preventFocus) this.openedBy = null;

          const videos = document.querySelectorAll('.infusion-video');

          if (videos.length > 0) {
            videos.forEach((video) => {
              video.play();
            });
          }
        }, 300);
      }

      show(opener) {
        // MNR-777: neue Session — Abandonment-Tracking zurücksetzen.
        this._addSucceeded = false;
        this._addPending = false;
        clearTimeout(this._addPendingTimer);
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');
        this.productUrl = opener.getAttribute('data-product-url');

        return fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.getElementById('quick-add-modal');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            
            this.addDropdownListeners();
            this.initFlavorSelector();
            this.initGallery();

            this._closing = false;
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
            // Add tracking event
            publish(PUB_SUB_EVENTS.openQuickAdd, { source: 'quick-add', modalContent: this.modalContent })
            // End tracking
          });
      }

      preprocessHTML(productElement) {
        this.updateVariantMap(productElement);
      }

      updateVariantMap(productElement) {
        const variantMapElement = productElement.querySelector('#variantMap')?.textContent || '';
        const newMap = JSON.parse(variantMapElement);
        this.variantMap = newMap;
      }

      addDropdownListeners() {
        // Dropdown flavor selector fallback
        const dropdowns = this.modalContent.querySelectorAll('[data-js="variant-selector"]');
        const variantOption1Selector = this.modalContent.querySelector('#option1-selector');
        const variantOption2Selector = this.modalContent.querySelector('#option2-selector');
        
        dropdowns.forEach((dropdown) => {
          dropdown.addEventListener('change', (event) => {
            let newVariant = this.variantMap.find((variant) => {
              return (
                variant.option1 === variantOption1Selector.value &&
                variant.option2 === variantOption2Selector?.value
              );
            });
            if (!newVariant) {      
              newVariant = this.variantMap.find((variant) => {
                return variant.option1 === variantOption1Selector.value;
              });
            }
            this.updateTemplate(newVariant.id);
          });
        });

        // Thumbnail flavor selector: option2 size selector
        const option2Selector = this.modalContent.querySelector('#option2-selector-variant');
        if (option2Selector) {
          option2Selector.addEventListener('change', () => {
            const option1Selector = this.modalContent.querySelector('#option1-selector-variant');
            let newVariant = this.variantMap.find((variant) => {
              return variant.option1 === option1Selector?.value && variant.option2 === option2Selector.value;
            });
            if (!newVariant) {
              newVariant = this.variantMap.find((variant) => {
                return variant.option1 === option1Selector?.value;
              });
            }
            if (newVariant) this.updateTemplate(newVariant.id);
          });
        }
      }

      updateTemplate(variantId) {
         const newUrl = this.productUrl.replace(/(variant=)\d+/, `$1${variantId}`);
         fetch(newUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.getElementById('quick-add-modal');
            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            
            this.addDropdownListeners();
            this.initFlavorSelector();
            this.initGallery();
            this.productUrl = newUrl;
            this.dispatchEvent(
              new CustomEvent('quick-add:template-updated', { bubbles: true, detail: { variantId } })
            );
          })
        }

      initFlavorSelector() {
        const flavorEl = this.modalContent.querySelector('[x-data*="flavorSelector"]');
        if (!flavorEl) return;

        if (window.Alpine) window.Alpine.initTree(flavorEl);

        this.removeFlavorChangeListener();
        this._flavorChangeHandler = (e) => {
          this.updateTemplate(e.detail.variantId);
        };
        window.addEventListener('flavor-selector:variant-changed', this._flavorChangeHandler);
      }

      removeFlavorChangeListener() {
        if (this._flavorChangeHandler) {
          window.removeEventListener('flavor-selector:variant-changed', this._flavorChangeHandler);
          this._flavorChangeHandler = null;
        }
      }

      initGallery() {
        const galleryEl = this.modalContent.querySelector('[x-data*="productImageGallery"]');
        if (galleryEl && window.Alpine) {
          window.Alpine.initTree(galleryEl);
        }
      }
    }
  );
}
